import React, { useState, useEffect } from 'react';
import { Table } from 'rbx';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { isNull, uniq } from 'lodash';
import { withRouter } from 'react-router-dom';
import FlagList from './FlagList';
import {
  Table as CustomTable,
  CustomInput,
  Pagination,
  Loading,
} from '../../../components/elements';

import client from '../../../utils/apolloClient';

const flaggedReviewQuery = gql`
  query flaggedReview($input: SearchInput) {
    search_flags(input: $input) {
      total_pages
      total_size
      flag_listing {
        flag_id
        flag_type
        flag_content
        status
        audit {
          created_at
          created_by
          updated_at
          updated_by
        }
      }
    }
  }
`;

const usersQuery = gql`
  query searchUsers($input: SearchInput) {
    search_users(input: $input) {
      user_listing {
        user_id
        display_name
        first_name
        last_name
        full_name
        email
      }
    }
  }
`;

const Flags = ({ match }) => {
  const [flagData, setFlagData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [pageFrom, setPageFrom] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalElements, setTotalElements] = useState();
  const [listSize] = useState(3);

  const flagFilter = {
    object_id: match.params.feedId,
  };

  const input = {};
  const flag_filter = {};

  Object.assign(input, flag_filter, { from: pageFrom, size: listSize });
  return (
    <React.Fragment>
      <br />
      {totalElements > 0 ? (
        <Pagination
          pageFrom={pageFrom}
          pageCount={pageCount}
          listSize={listSize}
          totalElements={totalElements}
          currentPage={currentPage}
          handlePageClick={value => {
            setPageFrom(value.selected * listSize);
            setCurrentPage(value.selected + 1);
          }}
        />
      ) : (
        ' '
      )}
      <CustomTable>
        <Table.Head>
          <Table.Row>
            <Table.Heading>
              <div>
                <span>
                  <i className="fas fa-sort-amount-down" /> User Display Name
                </span>
                {/* <br />
                <CustomInput /> */}
              </div>
            </Table.Heading>
            <Table.Heading>
              <div>
                <span>
                  <i className="fas fa-sort-amount-down" /> User Login
                </span>
                {/* <br />
                <CustomInput /> */}
              </div>
            </Table.Heading>
            <Table.Heading>Updated At</Table.Heading>
            <Table.Heading>Flag Content</Table.Heading>
          </Table.Row>
        </Table.Head>

        <Query
          client={client.clientPrivate}
          query={flaggedReviewQuery}
          variables={{ input: { filter: { flag_filter: flagFilter } } }}
          fetchPolicy="network-only"
        >
          {({ data, loading, error }) => {
            if (loading) {
              return <Loading />;
            }
            if (error) {
              return 'error';
            }
            const { search_flags } = data;

            if (isNull(search_flags)) {
              return <tbody>No Data Found</tbody>;
            }

            return (
              <React.Fragment>
                <View
                  flagData={flagData}
                  setFlagData={setFlagData}
                  search_flags={search_flags}
                  setPageCount={setPageCount}
                  setTotalElements={setTotalElements}
                />
              </React.Fragment>
            );
          }}
        </Query>
      </CustomTable>
    </React.Fragment>
  );
};

const View = ({
  search_flags,
  setPageCount,
  setTotalElements,
  setFlagData,
  flagData,
}) => {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    setPageCount(search_flags.total_pages);
    setTotalElements(search_flags.total_size);

    if (search_flags.flag_listing) {
      setFlagData(search_flags.flag_listing);

      const userFilter = search_flags.flag_listing.map(
        item => item.audit.updated_by,
      );
      client.clientPrivate
        .query({
          query: usersQuery,
          variables: {
            input: { filter: { user_filter: { user_id: uniq(userFilter) } } },
          },
        })
        .then(({ data: { search_users } }) => {
          console.log('result');

          if (search_users) {
            setUsers(search_users.user_listing);
          }
        });
    }
  }, [search_flags.total_pages]);

  return (
    <tbody>
      {flagData.map(flag => (
        <tr key={flag.flag_id}>
          <FlagList flag={flag} users={users} />
        </tr>
      ))}
    </tbody>
  );
};

export default withRouter(Flags);
